import React, { Component } from 'react'
import styled from 'styled-components'
import SashecAdvertPositionWrapper from './SashecAdvertPositionWrapper'

const AD_BOTTOM_MARGIN = 20
const SPACE_BETWEEN_WIDGETS = 30

const StickyElement = styled.div`
  &.sticky {
    position: fixed;
    top: ${props => props.sticky.offsetTop + AD_BOTTOM_MARGIN + SPACE_BETWEEN_WIDGETS}px;
    width: ${props => props.sticky.width}px;
  }
`

export default class StickyHalfpage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isSticky: false,
      offsetTop: 0,
      width: 0
    }

    this.handleScroll = this.handleScroll.bind(this)
  }

  componentDidMount () {
    const halfPage = document.getElementById('reklama-halfpage')
    const headerElement = document.getElementById('header')
    const newsFeedElement = document.getElementById('newsfeed-container')
    const previousWidget = this.wrapper.parentNode.previousSibling
    const width = this.wrapper.clientWidth

    this.setState({
      halfPage,
      headerElement,
      newsFeedElement,
      previousWidget,
      width
    })

    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount () {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll () {
    const {
      halfPage,
      headerElement,
      isSticky,
      newsFeedElement,
      offsetTop,
      previousWidget
    } = this.state

    if (!newsFeedElement) return
    const adHeight = (halfPage && halfPage.offsetHeight) || 0
    const newsFeedPosition = newsFeedElement.getBoundingClientRect().bottom
    const newIsSticky = previousWidget.getBoundingClientRect().bottom - headerElement.offsetHeight < SPACE_BETWEEN_WIDGETS

    const newOffsetTop = newsFeedPosition <= adHeight + headerElement.offsetHeight + SPACE_BETWEEN_WIDGETS + AD_BOTTOM_MARGIN
      ? newsFeedPosition - adHeight - headerElement.offsetHeight
      : headerElement.offsetHeight - AD_BOTTOM_MARGIN

    if (isSticky !== newIsSticky) {
      this.setState({
        isSticky: false
      })
    }

    if (offsetTop !== newOffsetTop) {
      this.setState({
        offsetTop: newOffsetTop
      })
    }
  }

  render () {
    const {
      isSticky,
      offsetTop,
      width
    } = this.state

    const {
      widget
    } = this.props

    const sticky = {
      offsetTop,
      width
    }

    return (
      <StickyElement sticky={sticky} className={isSticky ? 'sticky' : ''} innerRef={el => {
        this.wrapper = el
      }}>
        <SashecAdvertPositionWrapper widget={widget}/>
      </StickyElement>
    )
  }
}
